export { default } from './ProductGallery'
